import { inventoryManagementAppStores } from "@intrasync/inventory-management";

/**
 * Inventory view stores — @intrasync/inventory-management
 *
 * The hub store drives the tab strip; the 16 feature view stores stay
 * registered because the hub Body renders the feature Bodies and calls each
 * feature store's load()/clear() on tab activation.
 */
const inventoryStoreList = [...inventoryManagementAppStores];

export default inventoryStoreList;
